import OnboardingService from "@/api/OnboardingService";
import { notifyApiError, notifyWarn, notify, notifyError } from "@/utils/notification-helper";
import MESSAGES from "@/utils/messages"
import { DEDICATED_DB_FEATURE_CODE } from "@/utils/constants";

const chekForErros = (data) => {
    if (!data.success && data.message && data.message.length) {
        data.message.forEach(notifyWarn)
    }
    return !data.success
}
const getDefaultDB = () => {
    return {
        configDBDetail: []
    }
}

// let getDefaultProduct = () => {
//     return [
//         {
//             "productID": null,
//             "packageID": null,
//             "productName":{},
//             "package":{}
//         }]
// }

const getDefaultState = () => {
    return {
        tenant: {
            id: "",
            name: "",
            clientId: 0,
            subDomain: "",
            website: "",
            contactPerson: "",
            contactNo: "",
            subscription: "",
            emailId: "",
            useSharedDb: true,
            configProfileId: 0,
            latitude: "",
            longitude: "",
            clientName: ""
        },
        // tenant: {
        //     id: "",
        //     name: "",
        //     subDomainName: "",
        //     website: "",
        //     contactPerson: "",
        //     contactNo: "",
        // },
        tenantUsers: [],
        tenantProduct: [],// getDefaultProduct(),
        packageFeatureDtos: [],
        tenantAddOns: [],
        tenantVendors: [],
        tenantSaaS: [
        ],
        user: {
            name: "",
            email: "",
            mobileNo: "",
            roles: 0,
            roleName: "",
            isDirty: false,
            isDeleted: false
        },
        product: {
            packageID: 0,
            productName: "",
            packageName: "",
            productID:0,
            isActive: false
        },
        // user: {
        //     id:"",
        //     name: "",
        //     email: "",
        //     mobileNo: "",
        //     role: "",
        //     "isDirty": false,
        // },
        database: getDefaultDB(),
        removedUsers: [],
        removedAddons: [],
        removedVendors: [],
        productId:null,
        roleId: null,
        packId:null,
        productArray:[],
        selected:0,
        tenantId: "",
        // clientId:null,
        editField: false,
        auditLogs: [],
        totalAuditLogs: 0
    }
}

const state = getDefaultState()

const getters = {
//  getProductDetails:(state,getters,rootState)=>()=>{
//      console.log(state.tenantProduct,rootState.products,rootState.products)
//  }

};
const actions = {
    resetState({ commit, dispatch }) {
        state.editField = false
        commit('resetState')
        dispatch('loadSaasConfig')
    },
    loadSaasConfig({ state, commit }) {
        if (!state.tenant.id) {
            OnboardingService.loadSaasConfig(state.tenant.id).then(({ data }) => {
                commit('setTenantSaaS', data)
            })
        }
    },
    async addTenant({ state,commit, dispatch }) {
        state.tenant.clientId = parseInt(state.tenant.clientId);
        state.tenantUsers = state.tenantUsers.map(item => {
            if(state.editField == true) {
                return {...item,isDirty: true };
            } else {
                return {...item};
            }
        })
        state.tenantProduct = state.tenantProduct.map(item => {
            if(state.editField == true) {
                return {...item,isDirty: true };
            } else {
                return {...item};
            }
        })
        let payload={
            tenant: state.tenant,
            tenantUsers: state.tenantUsers,
            packageFeatureDtos : state.packageFeatureDtos,
            tenantProducts : state.tenantProduct,
            ConfigDbDetails: {
                configDBDetail: state.tenant.useSharedDb == true ? [] : state.database.configDBDetail,
                description: state.tenant.name + " database profile",
                id: state.tenant.configProfileId,
                isDefault: state.tenant.useSharedDb == true ? true : false,
                isSharedDb: state.tenant.useSharedDb,
                name: state.tenant.name + "_config"
            },
            id: ""
        }
        if (state.tenant.contactNo !== "" && state.tenant.contactPerson !== "" && state.tenant.emailId !== "" && state.tenant.name !== "" && state.tenant.website !== "" &&
        state.tenant.subDomain !== "" && state.tenant.latitude !== "" && state.tenant.longitude !== "") {
            const { data } = await OnboardingService.addTenantDtls(payload);
            if (!chekForErros(data)) {
                commit('setTenant', data.alltenantDetails.tenant)
                dispatch("loadTenants", null, { root: true });
                if(state.editField == false) {
                    return MESSAGES.CREATE_TENANT_SUCCESS
                } else {
                    return MESSAGES.UPDATE_TENANT_SUCCESS
                }
            } else {
                throw new Error(MESSAGES.RESOLVE_ERRORS)
            }
        } else {
            throw new Error('Please Fill the Tenant Details')
        }
    },
    async activateTenantDtls({ commit, state, dispatch }) {
        state.tenant.clientId = parseInt(state.tenant.clientId)
        state.tenant.activated = true;
        state.tenantUsers = state.tenantUsers.map(item => {
            if(state.editField == true) {
                return {...item,isDirty: true };
            } else {
                return {...item};
            }
        })
        state.tenantProduct = state.tenantProduct.map(item => {
            if(state.editField == true) {
                return {...item,isDirty: true };
            } else {
                return {...item};
            }
        })
        let payload={
            tenant: state.tenant,
            tenantUsers: state.tenantUsers,
            packageFeatureDtos : state.packageFeatureDtos,
            tenantProducts : state.tenantProduct,
            ConfigDbDetails: {
                configDBDetail: state.tenant.useSharedDb == true ? [] : state.database.configDBDetail,
                description: state.tenant.name + " database profile",
                id: state.tenant.configProfileId,
                isDefault: state.tenant.useSharedDb == true ? true : false,
                isSharedDb: state.tenant.useSharedDb,
                name: state.tenant.name + "_config"
            },
            id: ""
        }
        if (state.tenant.contactNo !== "" && state.tenant.contactPerson !== "" && state.tenant.emailId !== "" && state.tenant.name !== "" && state.tenant.website !== "" &&
        state.tenant.subDomain !== "" && state.tenant.latitude !== "" && state.tenant.longitude !== "") {
            let { data } = await OnboardingService.activateTenantDtls(payload);     
            if (!chekForErros(data)) {
                commit('setTenant', data.alltenantDetails.tenant)
                dispatch("loadTenants", null, { root: true });
                return MESSAGES.TENANT_ACTIVATED
            } else {
                throw new Error(MESSAGES.RESOLVE_ERRORS)
                // throw new Error(data.message)
            }
        }else {
            throw new Error('Please Fill the Tenant Details')
        } 
    },
    
    // async addTenant({ state, commit }) {
    //     if (!state.tenant.id) {
    //         const { data } = await OnboardingService.addTenant(state.tenant); 
    //         if (!chekForErros(data)) {
    //             commit('setTenant', data.result)
    //             return MESSAGES.CREATE_TENANT_SUCCESS
    //         } else {
    //             throw new Error(MESSAGES.RESOLVE_ERRORS)
    //         }
    //     } else {
    //         const { data } = await OnboardingService.updateTenant(state.tenant.id, state.tenant)
    //         if (!chekForErros(data)) {
    //             return MESSAGES.UPDATE_TENANT_SUCCESS
    //         } else {
    //             throw new Error(MESSAGES.UPDATE_TENANT_FAILED)
    //         }
    //     }
    // },
    // async saveUsers({ state, commit }) {
    //     console.log("State : ",state)
    //     if (!state.tenant.id) {
    //         throw new Error('Please create a tenant first')
    //     }
    //     if (state.removedUsers.length) {
    //         await OnboardingService.removeUsers(state.tenant.id, state.removedUsers);
    //         commit('resetRemoved');
    //     }

    //     const { data } = await OnboardingService.addUsers(state.tenant.id, state.tenantUsers.map(u => {
    //         return { ...u, tenantID: state.tenant.id }
    //     }))

    //     if (!chekForErros(data)) {
    //         commit('setUsers', data.result);
    //         return MESSAGES.SAVE_USER_SUCCESS
    //     } else {
    //         throw new Error(MESSAGES.SAVE_USER_FAILED)
    //     }
    // },
    // async saveUsers({ state, commit }) {
    //     if (!state.tenant.id) {
    //         throw new Error('Please create a tenant first')
    //     }
    //     if (state.removedUsers.length) {
    //         await OnboardingService.removeUsers(state.tenant.id, state.removedUsers);
    //         commit('resetRemoved');
    //     }
    //     let payload= {
    //         id: state.tenant.id,
    //         tenantUsers: state.tenantUsers
    //     }
    //     const { data } = await OnboardingService.addUserDtls(payload)

    //     if (!chekForErros(data)) {
    //         commit('setUsers', state.tenantUsers);
    //         return MESSAGES.SAVE_USER_SUCCESS
    //     } else {
    //         throw new Error(MESSAGES.SAVE_USER_FAILED)
    //     }
    // },
      
    async saveProduct({ state, commit }) {
        if (!state.tenant.id) {
            throw new Error('Please create a tenant first')
        }
        // const products = state.tenantProduct.map(product => {
        //     if (!product.productID || !product.packageID) {
        //         // delete product
        //         //  throw new Error('Please fill in required fields');
        //     }
        //     return { ...product, productID: +product.productID, packageID: +product.packageID, tenantID: state.tenant.id }
        // });
        const payload= {
            id: state.tenant.id,
            packageFeatureDtos : state.packageFeatureDtos
        }
        const { data } = await OnboardingService.addProducts(payload);
        if (!chekForErros(data)) {
            commit('setProduct', data.alltenantDetails.packageFeatureDtos)
            return MESSAGES.SAVE_PRODUCT_SUCCESS
        } else {
            throw new Error(MESSAGES.SAVE_PRODUCT_FAILED)
        }

    },
    addAddons({ rootGetters, commit, state }, addons) {
        const existingAddonID = state.tenantAddOns.map(addon => addon.featureID);
        const newAddons = addons.filter(addon => !existingAddonID.includes(addon)).
            map(addon => rootGetters.getAddOnByID(addon))
            .map(addon => {
                return {
                    featureID: addon.id,
                    tenantID: state.tenant.id,
                    dedicatedDB: addon.featureCode == DEDICATED_DB_FEATURE_CODE
                }
            });

        if (newAddons.find(addon => addon.dedicatedDB)) {
            commit('setSharedDB', false);
            commit('resetDB')
        }

        const removedAddons = existingAddonID.filter(addon => !addons.includes(addon))
            .map(rootGetters.getAddOnByID)
            .map(addon => {
                return {
                    featureID: addon.id,
                    tenantID: state.tenant.id,
                    dedicatedDB: addon.featureCode == DEDICATED_DB_FEATURE_CODE
                }
            });

        if (removedAddons.find(addon => addon.dedicatedDB)) {
            commit('setSharedDB', true);
            commit('resetDB')
        }

        commit('addAddons', newAddons);
        commit('removeAddons', removedAddons)

    },
    addVendors({ rootGetters, commit, state }, vendors) {
        const existingVendorID = state.tenantVendors.map(vendor => vendor.id);
        const newVendors = vendors.filter(vendor => !existingVendorID.includes(vendor)).
            map(vendor => rootGetters.getVendorByID(vendor))
        const removedVendors = existingVendorID.filter(vendor => !vendors.includes(vendor))
            .map(rootGetters.getVendorByID)
        commit('addVendors', newVendors)
        commit('removeVendors', removedVendors)

    },
    async saveAddons({ state, commit }) {
        if (!state.tenant.id) {
            throw new Error('Please create a tenant first')
        }

        if (state.removedAddons.length) {
            await OnboardingService.removeAddons(state.tenant.id, state.removedAddons.filter(addon => addon.id));//only remove saved addons
            commit("clearRemovedAddons")
        }
        const { data } = await OnboardingService.saveAddons(state.tenant.id, state.tenantAddOns);
        if (!chekForErros(data)) {
            commit("setAddOns", data.result);
            return MESSAGES.SAVE_ADDON_SUCCESS
        } else {
            throw new Error(MESSAGES.SAVE_ADDON_FAILED)
        }
    },
    async saveVendors({ state, commit }) {
        if (!state.tenant.id) {
            throw new Error('Please create a tenant first')
        }
        if (state.removedVendors.length) {
            await OnboardingService.removeVendors(state.tenant.id, state.removedVendors.filter(vendor => vendor.id));
            commit("clearRemovedVendors")
        }
        const { data } = await OnboardingService.saveVendors(state.tenant.id, state.tenantVendors);
        if (!chekForErros(data)) {
            commit("setVendors", data.result);
            return MESSAGES.SAVE_VENDOR_SUCCESS
        } else {
            throw new Error(MESSAGES.SAVE_VENDOR_FAILED)
        }
    },
    async saveDatabase({ state }) {
        if (!state.tenant.id) {
            throw new Error('Please create a tenant first')
        }

        if (state.tenant.useSharedDb) {
            if (state.database.id) {
                await OnboardingService.saveConfigProfile(state.tenant.id, state.database.id);
                return MESSAGES.SAVE_DATABASE_SUCCESS
            } else {
                throw new Error('Select a configuration from the dropdown')
            }
        } else {
            if (state.database.id) {
                await OnboardingService.saveBulkDBConfig(state.database)
                return MESSAGES.SAVE_DATABASE_SUCCESS
            } else {
                throw new Error('Please create a configuration profile')
            }
        }
    },
    async saveSaasConfig({ state, commit }) {
        if (!state.tenant.id) {
            throw new Error('Please create a tenant first')
        }
        const { data } = await OnboardingService.saveSaasConfig(state.tenant.id, state.tenantSaaS)
        commit('setTenantSaaS', data)
        return MESSAGES.SAVE_SAAS_SUCCESS
    },
    createProfileConfig({ state, commit }) {
        if (!state.tenant.id) {
            return notifyWarn('Please create a tenant first')
        }
        const profile = {
            name: state.tenant.name + "_config",
            description: state.tenant.name + " database profile",
            isDefault: false,
            isShared: false
        }
        OnboardingService.createProfileConfig(state.tenant.id, profile).then(({ data }) => {
            commit('setDatabaseProfile', data)
        }).catch(notifyApiError)
    },
    
    // async activateTenant({ state }) {
    //     if (!state.tenant.id) {
    //         return notifyWarn('Please create a tenant first')
    //     }
    //     if (state.tenant.activated) {
    //         return  //Tenant is already activated.
    //     }
    //     await OnboardingService.activateTenant(state.tenant.id)
    //     return MESSAGES.TENANT_ACTIVATED
    //     //     .then(() => {
    //     //     notify('Tenant Activated Successfully')
    //     // }).catch(notifyApiError);
    // },
    async loadTenant({ commit,dispatch }, tenant) {
        state.editField = true
        const results = await OnboardingService.loadTenant(tenant.id, tenant.configProfileId);
        commit('loadTenant', results.map(res => res.data))
        dispatch('getProductData', results.map(res => res.data))
    },
    getProductData({commit,rootState},data){
        let product = data[0].tenantProducts.length ? data[0].tenantProducts : [];
        product.map(i=>{
         if(i.productID){
             i.productName=rootState.products.find((obj) => obj.id == i.productID).name;
         }
         if(i.packageID){
            i.packName=rootState.packageData.filter((obj=>obj.productID==i.productID)).find((obj) => obj.id == i.packageID);
        }
      })
      commit("loadProduct",product)
    },
    async removeTenant({ dispatch }, tenant) {
        await OnboardingService.removeTenant(tenant.id);
        dispatch("loadTenants", null, { root: true });
        return MESSAGES.TENANT_REMOVED
    },
    async testConnection(store, config) {
        OnboardingService.testConnection(config.item.connectionString).then(() => {
            notify(MESSAGES.CONNECTION_SUCCESS);
        }).catch(() => {
            notifyError(MESSAGES.CONNECTION_FAILED)
        });
    },
    async addProducts({state, commit}){
        // let data = {packageID: state.packId, productID: state.productId, tenantID: state.tenant.id ,productName:rootState.products.find((obj) => obj.id ==  state.productId),package:rootState.packageData.filter((obj=>obj.productID==state.productId)).find((obj) => obj.id == state.packId)}
        let { data } = await OnboardingService.addProd(state.productId, state.packId)
        let productData= {
            id: 0,
            productID: data.productID,
            productName: data.productName,
            packageName: data.name,
            isDirty: false,
            packageId: parseInt(state.packId),
        }
        // if (state.tenantProduct.find(u => u.packageId == productData.packageId && u.productID == productData.productID)) {
        //     return notifyError("Package and Product already exist")
        // }
        if (state.tenantProduct.find(u => u.productID == productData.productID)) {
            return notifyError("Product already exist")
        }
        commit("addProduct",productData)
        commit("addPackageFeatureDtos",data)
      },
      async editProducts({state, commit}){
        let { data } = await OnboardingService.addProd(state.productId, state.packId)
        let productData= {
            id: 0,
            productID: data.productID,
            productName: data.productName,
            packageName: data.name,
            isDirty: false,
            packageId: parseInt(state.packId),
        }
        commit("editProduct",productData)
        commit("editPackageFeatureDtos",data)
      },
    addUser({ rootState, state, commit }) {
        if (state.tenantUsers.find(u => u.email == state.user.email)) {
            return notifyError(MESSAGES.USER_EMAIL_EXISTS)
        }
        commit("addUser", rootState.tenantRoles)
    },
    editUser({ rootState, state, commit }) {
        if (state.tenantUsers.find(u => u.email == state.user.email)) {
            commit("editUser", rootState.tenantRoles)
        }
    },
    resetDB({ commit }) {
        commit('resetDB') //TODO logic to get the existing profile for user??
    },
    async activation({commit,rootState},data){
        let payLoad={
            tenantID:data.id,
            isActivated:data.activated
        }
        const resp = await OnboardingService.tenantActivation(payLoad);

        if(resp.data?.status === false){
            data.activated = !data.activated;
            const status = data.activated ? 'active' : 'deactive';
            const message = resp.data?.message ? resp.data?.message : `Unable to ${status} the tenant}`;
            notify(message);
        }
        else{
            if(data.activated == true) {
            return notify(MESSAGES.TENANT_ACTIVATED);
            } else {
            return notify(MESSAGES.TENANT_DEACTIVATED);
            }
        }
        rootState.tenants.map(i=>{if(i.id==data.id){
            i.activated = data.activated;
        }})
        commit("assignActivatedData",data)
    },

    async cancelation({rootState},data){
        rootState.tenants.map(i=>{if(i.id==data.id){
            i.activated = !data.activated
        }})
    },
    setSelectedTab(selected) {
        this.$store.commit('setSelectedTab', selected);
    },
    async getAuditLogs({commit}, data){
        let auditLog = await OnboardingService.getAuditLogs(data.tenantId, data.pageSize, data.pageNo);
        if(auditLog.status == 200){
            commit('setAuditLog', auditLog.data.result)
            commit('setTotalAuditLogs', auditLog.data.totalDataCount);
        }
    }

};
const mutations = {
    addUser(state, data) {
        state.tenantUsers.push({ ...state.user });
        state.tenantUsers.forEach(element => {
            element.roleName = data.find(item =>  item.id == element.roles)?.roleName;
        });
        state.user.id = 0;
        state.user.name = "";
        state.user.email = "";
        state.user.mobileNo = "";
        state.user.roleName = "";
        state.user.roles = 0;
        state.user.isDirty = false;
    },
    editUser(state, data) {
        state.tenantUsers.forEach(element => {
            if(element.email == state.user.email) {
                element.mobileNo = state.user.mobileNo;
                element.email = state.user.email;
                element.name= state.user.name;
                element.id = state.user.id;
                element.roles= state.user.roles;
                element.isDirty = true;
            }
            element.roleName = data.find(item =>  item.id == element.roles)?.roleName;
        });
        state.user.id = 0;
        state.user.name = "";
        state.user.email = "";
        state.user.mobileNo = "";
        state.user.roleName = "";
        state.user.roles = 0;
        state.user.isDirty = false;
    },
    addProduct(state, data) {
        state.tenantProduct.push(data)
    },
    editProduct(state, data) {
        state.tenantProduct.forEach(element => {
            if(element.productID == data.productID) {
                element.packageId = data.packageId;
                element.packageName = data.packageName;
                element.productID= data.productID;
                element.id = data.id;
                element.productName= data.productName;
                element.isDirty = true;
            }
        });
    },
    removeUser(state, removed ) {
        // if (!removed.id) {
        //     state.tenantUsers.splice(index, 1);
        // }else {
            // state.tenantUsers = state.tenantUsers.filter(user => user.email !== removed.email && user.id !== removed.id)

            // if (removed.id) {//only the existing user in db should be removed
            //     state.removedUsers.push({ ...removed })
            // }
            if(state.editField == false) {
            state.tenantUsers = state.tenantUsers.filter(user => user.email !== removed.email)
            } else {
            state.tenantUsers.forEach(item => {
                if(item.email == removed.email) {
                    item.isDeleted = true;
                }
            });
            }
            if (removed.id) {
                state.removedUsers.push({ ...removed })
            }
            
        // }  
    },
    setTenant(state, tenant) {
        state.tenant = tenant;
    },
    setSelectedTab(state, selected) {
        state.selected = selected
    },
    setProduct(state, product) {
        state.tenantProduct = product;
    },
    addPackageFeatureDtos(state,data) {
        state.packageFeatureDtos.push(data)
    },
    editPackageFeatureDtos(state,data) {
        state.packageFeatureDtos.forEach(element => {
            if(element.productID == data.productID) {
                element.features = data.features;
                element.id = data.id;
                element.modules = data.modules;
                element.name = data.name;
                element.productID= data.productID;
                element.productName= data.productName;
                element.isDirty = true;
            }
        });
    },
    setUsers(state, users) {
        state.tenantUsers = users;
    },
    setConnectionString(state, connection) {
        const config = state.database.configDBDetail.find(item => connection.item.id == item.id && connection.item.microserviceName == item.microserviceName);
        config.connectionString = connection.value;
    },
    setTenantSaaS(state, tenantSaaS) {
        state.tenantSaaS = tenantSaaS;
    },
    setDatabaseProfile(state, database) {
        state.database = database;
    },
    loadTenant(state, data) {
        const tenant = data[0];
        const tenantDatabase = data[1];
        state.tenant = tenant.tenant;
        // state.tenantProduct = tenant.tenantProducts.length ? tenant.tenantProducts : getDefaultProduct();
        state.tenantAddOns = tenant.tenantAddonFeatures;
        state.tenantSaaS = tenant.tenantSettings;
        state.tenantUsers = tenant.tenantUsers;
        state.packageFeatureDtos = tenant.packageFeatureDtos;
        state.database = tenantDatabase ? tenantDatabase : getDefaultDB();
        // state.tenantProduct.map(i=>{
        //     console.log("get product data",i)
        // })
        
    
    },
    loadProduct(state,tenant){
        state.tenantProduct = tenant
    },
    setSharedDB(state, useSharedDB) {
        state.tenant.useSharedDb = useSharedDB;
    },
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    resetRemoved(state) {
        state.removedUsers = []
    },
    resetDB(state) {
        state.database = getDefaultDB();
    },
    addAddons(state, addons) {
        state.tenantAddOns.push(...addons)
    },
    addVendors(state, vendors) {
        state.tenantVendors.push(...vendors)
    },
    removeAddons(state, addons) {
        const ids = addons.map(addon => addon.featureID);
        state.removedAddons.push(...state.tenantAddOns.filter(addon => ids.includes(addon.featureID)))
        state.tenantAddOns = state.tenantAddOns.filter(addon => !ids.includes(addon.featureID))
    },
    removeVendors(state, vendors) {
        const ids = vendors.map(vendor => vendor.id);
        state.removedVendors.push(...state.tenantVendors.filter(vendor => ids.includes(vendor.id)))
        state.tenantVendors = state.tenantVendors.filter(vendor => !ids.includes(vendor.id))
    },
    setAddOns(state, addons) {
        state.tenantAddOns = addons;
    },
    setVendors(state, vendors) {
        state.tenantVendors = vendors;
    },
    clearRemovedAddons(state) {
        state.removedAddons = []
    },
    clearRemovedVendors(state) {
        state.removedVendors = []
    },
    assignActivatedData(state,data){
      console.log(state,data)
    },
    productEvent(state, e){
        state.productId = e.sender.value()
    },
    changeProductId(state, id) {
        state.productId = id;
    },
    packageEvent(state,e){
        state.packId = e.sender.value()
    },
    // clientIdEvent(state,e) {
    //     state.clientId = e.sender._cascadedValue
    // },
    removeProduct(state, index){
        state.tenantProduct.splice(index, 1);
        state.packageFeatureDtos.splice(index, 1);
        // console.log(state.tenantProduct)
        // console.log("Selcted Product ",productDetail)
        // state.tenantProduct = state.tenantProduct.filter(user => user.packageId !== productDetail.packageId && user.productID !== productDetail.productID)
        // state.packageFeatureDtos = state.tenantProduct.filter(user => user.packageId !== productDetail.packageId && user.productID !== productDetail.productID)
    },
    setAuditLog(state, data){
        state.auditLogs = data;
    },
    setTotalAuditLogs(state, data){
        state.totalAuditLogs = data;
    }
 
    
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}